import { render, staticRenderFns } from "./PeripheralAccessHelperModal.vue?vue&type=template&id=4a2709b9&scoped=true"
import script from "./PeripheralAccessHelperModal.vue?vue&type=script&lang=js"
export * from "./PeripheralAccessHelperModal.vue?vue&type=script&lang=js"
import style0 from "./PeripheralAccessHelperModal.vue?vue&type=style&index=0&id=4a2709b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2709b9",
  null
  
)

export default component.exports